<div class="page-data">
    <app-advanced-search (formData)="applyFilters($event)" [config]="filterConfig"> </app-advanced-search>
    <div class="p-relative c-table">
        <app-loader [isLoading]="fileTableService.loading()" />
        <app-common-table
            [config]="tableConfig"
            [service]="fileTableService"
        >
        </app-common-table>
    </div>
</div>
